import { Link } from "react-router-dom";
import "./Footer.css";

const COLS = [
  {
    title: "Tool",
    links: [
      { to: "/", label: "EPS Viewer" },
      { to: "/guides/convert-eps-to-png", label: "Convert EPS to PNG" },
      { to: "/guides/how-to-open-eps-files", label: "How to Open EPS" },
    ],
  },
  {
    title: "Guides",
    links: [
      { to: "/guides", label: "All Guides" },
      { to: "/guides/what-is-an-eps-file", label: "What Is an EPS File" },
      { to: "/guides/eps-vs-svg-vs-ai-vs-pdf", label: "EPS vs SVG vs AI vs PDF" },
      { to: "/guides/fix-eps-file-problems", label: "Fix EPS Problems" },
    ],
  },
  {
    title: "Convert",
    links: [
      { to: "/guides/convert-eps-to-png", label: "EPS to PNG" },
      { to: "/guides/convert-eps-to-jpg", label: "EPS to JPG" },
      { to: "/guides/convert-eps-to-pdf", label: "EPS to PDF" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/faq", label: "FAQ" },
      { to: "/glossary", label: "Glossary" },
      { to: "/guides/vector-vs-raster", label: "Vector vs Raster" },
      { to: "/guides/eps-file-format-explained", label: "EPS Format Explained" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about-magicapps", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms" },
      { to: "/disclaimer", label: "Disclaimer" },
      { to: "/cookie-policy", label: "Cookie Policy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brandcol">
          <Link to="/" className="footer__brand">
            <span className="footer__mark">EPS</span> EPS&nbsp;Viewer
          </Link>
          <p className="footer__tag">
            Free online EPS viewer &amp; converter. Open, preview and convert
            Encapsulated PostScript files right in your browser — no software,
            no signup.
          </p>
        </div>

        {COLS.map((col) => (
          <div className="footer__col" key={col.title}>
            <h4>{col.title}</h4>
            {col.links.map((l) => (
              <Link key={l.to + l.label} to={l.to}>{l.label}</Link>
            ))}
          </div>
        ))}
      </div>

      <div className="footer__bottom container">
        <span>© {new Date().getFullYear()} EPS Viewer. All rights reserved.</span>
        <span>Built by <a href="https://magicapps.co.in/" target="_blank" rel="noopener noreferrer">MagicApps</a>.</span>
      </div>
    </footer>
  );
}
